export const to = promise => (
promise ? promise.then(data => [null, data])
    .catch(err => [err, null])
    : [null, null]
);